import { useEffect } from "react";

/** Keep learning controls above the on-screen keyboard without replacing it. */
export function useVisualViewportHeight(): void {
  useEffect(() => {
    const viewport = window.visualViewport;
    const update = (): void => {
      const height = viewport?.height ?? window.innerHeight;
      document.documentElement.style.setProperty(
        "--app-viewport-height",
        `${height}px`,
      );
      const editing = document.activeElement?.matches(
        "input, textarea, [contenteditable='true']",
      );
      document.body.dataset.keyboardOpen = String(
        Boolean(editing && height < window.innerHeight * 0.75),
      );
    };
    update();
    viewport?.addEventListener("resize", update);
    window.addEventListener("resize", update);
    document.addEventListener("focusin", update);
    document.addEventListener("focusout", update);
    return (): void => {
      viewport?.removeEventListener("resize", update);
      window.removeEventListener("resize", update);
      document.removeEventListener("focusin", update);
      document.removeEventListener("focusout", update);
      document.documentElement.style.removeProperty("--app-viewport-height");
      delete document.body.dataset.keyboardOpen;
    };
  }, []);
}
